/** "Schedule WhatsApp" entry point for business record lists. Navigates to the Bulk Schedule wizard with the selected record ids. */
import { useNavigate } from "react-router-dom";
import { MessageCircle } from "lucide-react";

export function ScheduleWhatsAppButton({ kind, ids = [], className = "", label = "Schedule WhatsApp" }) {
  const nav = useNavigate();
  const list = (ids || []).filter(Boolean);
  return (
    <button type="button" onClick={() => nav(`/admin/integrations/whatsapp?tab=bulk-schedule&kind=${kind}&ids=${encodeURIComponent(list.join(","))}`)}
      className={"h-9 px-3 rounded-full border border-emerald-600 text-emerald-700 bg-white text-[12px] font-medium inline-flex items-center gap-1.5 disabled:opacity-40 " + className} data-testid={`schedule-whatsapp-${kind}`} title={list.length ? `${list.length} selected` : "Open the WhatsApp bulk scheduler"}>
      <MessageCircle className="h-3.5 w-3.5" /> {label}{list.length ? ` (${list.length})` : ""}
    </button>
  );
}
